let timeout = 0;

const startTimer = () => {
    setInterval(() => {
        update();
    }, 1000);
};

const update = () => {
    timeout = Math.max(timeout - 1000, 0);
    // return output to web worker
    postMessage(timeout);
};

// receive the timeout data
self.addEventListener("message", function(e) {
    // the passed-in data is available via e.data
    timeout = parseInt(e.data);
    update();
    startTimer();
}, false);